"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.CarouselRoot = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  maxWidth: 985,
  flexDirection: 'column',
  gap: theme.spacing(4),
  margin: theme.spacing(0, 'auto'),
  flexWrap: 'wrap',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(8)
  }
}));
const CarouselRoot = exports.CarouselRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  margin: theme.spacing(0, 'auto'),
  width: '100%',
  maxWidth: 985
}));
